import Button from 'components/button'
import SetupFreestyleRounds from './setup-rounds'
import useFreestyleSetup from 'lib/hooks/useFreestyleSetup'
import FavoriteButton from 'components/workouts/favorite-button'

interface Props {
  startFreestyle: () => void
}

const LoggedIn = ({ startFreestyle }: Props) => {
  const { rounds, seconds, rest, addSeconds, removeSeconds, addRound, removeRound, addRest, removeRest } =
    useFreestyleSetup()

  return (
    <>
      <SetupFreestyleRounds
        rounds={rounds}
        seconds={seconds}
        rest={rest}
        addSeconds={addSeconds}
        removeSeconds={removeSeconds}
        addRound={addRound}
        removeRound={removeRound}
        addRest={addRest}
        removeRest={removeRest}
      />
      <div className="popupFreestyle__buttons">
        <div />
        <div />
        <div className="popupFreestyle__buttons--right popupFreestyle__actionGroup">
          <FavoriteButton />
          <Button fullColor customClickEvent={startFreestyle}>
            <h3>Start Freestyle</h3>
          </Button>
        </div>
      </div>
    </>
  )
}

export default LoggedIn
